/* eslint-disable no-empty-pattern */
import { Button, DialogActions, Typography } from '@material-ui/core';
import React from 'react';
import Draggable from 'react-draggable';
import { DragHandle, InnerContentWrapper, OuterContentWrapper, Wrapper } from './FloatingPaper.Styles';
export var FloatingPaper = function (_a) {
    var title = _a.title, actions = _a.actions, open = _a.open, children = _a.children;
    return React.createElement(Wrapper, { open: open },
        React.createElement(Draggable, { handle: "#handle", defaultPosition: { x: 0, y: 0 }, 
            // grid={[1, 1]}
            scale: 1 },
            React.createElement(OuterContentWrapper, { elevation: 3 },
                React.createElement(DragHandle, { id: "handle" },
                    React.createElement(Typography, { variant: "h6", component: "h2" }, title)),
                React.createElement(InnerContentWrapper, null, children),
                (actions === null || actions === void 0 ? void 0 : actions.length) &&
                    React.createElement(DialogActions, null, actions.map(function (action) { return React.createElement(Button, { autoFocus: true, onClick: function () { return action.onClick(); }, color: "primary" }, action.title); })))));
};
FloatingPaper.defaultProps = {
// bla: 'test',
};
//# sourceMappingURL=FloatingPaper.js.map